import { Action } from "components/actions/actions";
import {
    InputComponent,
    isComponentWithOptions,
    isDisplayedComponent,
    isValidationStatusComponent,
    isValueComponent,
    ValueComponentDefinition,
} from "components/components/Component";
import { InputBaseComponent } from "components/components/InputBaseComponent";
import { InputBaseComponent as InputBaseInputComponent } from "components/input/baseInputDefinition";
import { ComponentActionEventDetail } from "components/events/componentActionHelper";
import { DataChangedEventDetail } from "components/form/dataChangedEventDetail";
import { Dictionary, Optgroup, Option } from "components/input/select/options";
import * as message from "components/message/message";
import { Renderer } from "components/Renderer";
import $ from "jquery";
import { ColumnDefinition } from "../columns/ColumnDefinitions";
import { ComponentColumnDefinition, isComponentColumnDefinition } from "../columns/ComponentColumn";
import { Table } from "../table";
import { TableDefinitionUtils } from "../tableDefinitionUtils";
import { TableRestrictionDataModel } from "../columns/data/tableRestrictionDataModel";
import { ActionComponent, Component } from "components/components/Component";
import { EventActionDefinition } from "components/events/eventActions";

export class TableAdditionInline {
    private table: Table;
    private tableFootView: HTMLTableSectionElement;
    private components: InputComponent[][] = [];
    private componentPositions: number[] = [];
    private rowValidity: boolean[] = [];
    private model: any[][] = [];
    private newRowCounter = 0;
    private restrictionsDataModel: TableRestrictionDataModel;
    private _readOnly: boolean;


    constructor(table: Table, tableFootView, restrictionsDataModel: TableRestrictionDataModel) {
        this.table = table;
        this.tableFootView = tableFootView;
        this.restrictionsDataModel = restrictionsDataModel;
    }

    public static renderAddition(table: Table, tableFootView, restrictionsDataModel: TableRestrictionDataModel) {
        if (table.definition.allowsInsert) {
            let listener = new TableAdditionInline(table, tableFootView, restrictionsDataModel);
            table.tableAdditionManager = listener;
            listener.addRow();
        }
    }

    public addRow() {
        if (this.table.definition.allowsInsert !== true) {
            return;
        }
        let rowComponents = [];
        let rowView = $("<tr class='c-table__addition-row'>");
        rowView.appendTo(this.tableFootView);
        let deleteIconPending = true;
        for (let i = 0; i < this.table.dataColumns.length; i++) {
            let cell = document.createElement("th");
            cell.setAttribute("data-column-index", i.toString());
            if (this.table.dataTable != null) {
                let swidth = parseInt(this.table.dataTable?.column(i).header().style.width, 10) + 21 - 8;
                cell.style.width = swidth.toString() + "px";
                cell.classList.add(this.table.dataTable.settings().init().columnDefs[i].className);
            }
            rowView.append(cell);
            const cd = this.table.dataColumns[i] as ColumnDefinition;
            if (cd.type === "CheckColumn" && deleteIconPending) {
                deleteIconPending = false;
                cell.innerHTML = '<i class="fa fa-trash-o c-table__new-row-trash"></i>';
                rowView.on("click", "i.c-table__new-row-trash", (evt) => {
                    this.deleteRow(evt.target as HTMLInputElement);
                });
                for (const actionEvent of this.table.definition.actionDeleteRows ?? []) {
                    rowView.on("click", "i.c-table__new-row-trash", (evt) => {
                        let view = evt.target as HTMLInputElement;
                        let eventActions = [{
                            "action": actionEvent,
                            "event": {
                                "type": "click"
                            }
                        }];
                        setTimeout(() =>
                            this.fireComponentActionEvent(view, null, eventActions[0] as EventActionDefinition)
                            , 0);
                    });
                }
            }
            this.insertComponentCell(cd, rowView, i, rowComponents);
        }
        this.components.push(rowComponents);

        this.table.restrictions.applyDependenciesToNewRow(
            this.components[this.components.length - 1],
            null,
            this.restrictionsDataModel);

        rowView[0].addEventListener("dataChanged", this.dataChangedCallback);
        rowView[0].addEventListener("focusout", this.focusoutListener);

        rowView[0].addEventListener("dataChangeRequest", this.dataChangeRequestCallback);

        rowView[0].addEventListener("componentActionEvent", (event: CustomEvent<ComponentActionEventDetail>) => {
            event.stopPropagation();
            let index = this.getRowIndexFromElement(event.target);
            let rowData = this.model[index];

            let data = {
                rowData,
            };
            if (event.detail.action.action["submitsTableData"] === true) {
                data["tableData"] = this.table.selectDataForAction(event.detail.action.action);
            }

            let dataholder = this.restrictionsDataModel.rowDataHolder(
                this.components[index],
                rowData,
                event.detail.action.action.actionName + "-" + index
            )
            new Action(event.detail.action.action, this.table).run(data, dataholder);
        });
    }

    public addNewRow(newRow: any[]) {
        let key = this.table.rowKey.key(newRow);
        if (this.checkExistingKeyInModel(key, this.table.rowKey)) {
            message.show({
                level: "warn",
                key: "base.add.already_exists",
            });
            return;
        }

        let rowComponents = [];
        let rowView = $("<tr class='c-table__addition-row'>");
        for (let i = 0; i < newRow.length; i++) {

            let cell = document.createElement("th");
            cell.setAttribute("data-column-index", i.toString());
            rowView.append(cell);
            const cd = this.table.dataColumns[i] as ColumnDefinition;
            if (cd.type === "CheckColumn") {
                cell.innerHTML = '<i class="fa fa-trash-o c-table__new-row-trash"></i>';
                rowView.on("click", "i.c-table__new-row-trash", (evt) => {
                    this.deleteRow(evt.target as HTMLInputElement);
                });
                for (const actionEvent of this.table.definition.actionDeleteRows ?? []) {
                    rowView.on("click", "i.c-table__new-row-trash", (evt) => {
                        let view = evt.target as HTMLInputElement;
                        let eventActions = [{
                            "action": actionEvent,
                            "event": {
                                "type": "click"
                            }
                        }];
                        setTimeout(() =>
                            this.fireComponentActionEvent(view, null, eventActions[0] as EventActionDefinition)
                            , 0);
                    });
                }
            } else {
                const element = newRow[i];
                let render = this.table.columnSettings[i].render as DataTables.FunctionColumnRender;
                cell.classList.add(this.table.columnSettings[i].className);
                let innerHTML = render(element, "display", newRow, null);
                if (innerHTML != null) {
                    cell.innerHTML = innerHTML;
                }
            }
            this.insertComponentCell(cd, rowView, i, rowComponents);
            let swidth = parseInt(this.table.dataTable?.column(i).header().style.width, 10) + 21 - 8;
            cell.style.width = swidth.toString() + "px";
        }
        if (rowComponents.length > 0) {
            this.table.restrictions.applyDependenciesToNewRow(
                rowComponents,
                newRow,
                this.restrictionsDataModel);
            this.rowValidity[this.model.length] = this.validate(newRow, rowComponents);
        }
        this.components.push(rowComponents);
        rowView[0].addEventListener("dataChanged", this.dataChangedCallback);
        this.model.push(newRow);

        rowView.appendTo(this.tableFootView);

        this.fireDataChanged();
    }

    private fireComponentActionEvent(view: Element, component: ActionComponent, actionEvent: EventActionDefinition) {
        view.dispatchEvent(new CustomEvent(
            "componentActionEvent",
            {
                bubbles: true,
                detail: {
                    component,
                    action: actionEvent,
                },
            }));
    }

    private insertComponentCell(cd, rowView, i, rowComponents) {
        if (cd.insertComponent != null || isComponentColumnDefinition(cd)) {
            let component = this.renderComponentCell(
                this.table,
                this.table.columnOptions,
                cd,
                rowView[0],
                [],
                999999999 + this.newRowCounter++,
                i,
            );
            rowComponents.push(component);
            this.componentPositions.push(i);
        }
    }

    private dataChangeRequestCallback = (event: CustomEvent) => {
        let suggestion = event.detail;
        let rowIdx = this.getRowIndexFromElement(event.target);
        this.model[rowIdx] = this.model[rowIdx] ?? [];
        for (let i = 0; i < this.table.dataColumns.length; i++) {
            let dataColumn = this.table.dataColumns[i];
            if (suggestion.data[dataColumn.property] === undefined) {
                continue;
            }
            if (dataColumn.insertComponent != null || dataColumn.type === "ComponentColumn") {
                let componentPosition = this.componentPositions.indexOf(i);
                let component = this.components[rowIdx][componentPosition];
                component.value(suggestion.data[dataColumn.property]);
            } else {
                let render = this.table.columnSettings[i].render as DataTables.FunctionColumnRender;
                let rendered = render(suggestion.data[dataColumn.property], "display", [], null);
                const selector = "tr:nth-child(" + (rowIdx + 1) + ") th:nth-child(" + (i + 1) + ")";
                this.tableFootView.querySelector(selector).innerHTML = rendered;
            }
            this.model[rowIdx][i] = suggestion.data[dataColumn.property];
        }
        let i = this.table.dataColumns.length;
        for (let extraField of this.table.definition.extraFields ?? []) {
            if (suggestion.data[extraField] !== undefined) {
                this.model[rowIdx][i] = suggestion.data[extraField];
            }
            i++;
        }

        let dataObject = TableDefinitionUtils.rowDataToObject(this.table.definition, this.model[rowIdx]);

        this.table.restrictions.applyDependenciesToNewRow(
            this.components[rowIdx],
            this.model[rowIdx],
            this.restrictionsDataModel);
        this.model[rowIdx] = TableDefinitionUtils.objectToRowData(this.table.definition, dataObject);
        this.rowValidity[rowIdx] = this.validate(this.model[rowIdx], this.components[rowIdx]);
        this.fireDataChanged();
    }

    public setOptions(options: Dictionary<Array<Option | Optgroup>>) {
        if (options == null) {
            return;
        }
        for (const component of this.components[0]) {
            if (isComponentWithOptions(component)) {
                component.addOptions(options[component.definition.property]);
            }
        }
    }

    public renderComponentCell(
        tableComponent: Table,
        columOptions: Dictionary<Array<Option | Optgroup>>,
        cd: ColumnDefinition,
        row,
        rowData: any[],
        rowIndex: number,
        index: number) {

        let renderer = Renderer.instance();
        let rendered;
        let input;
        const definition =
            ((cd as ComponentColumnDefinition).component ?? cd.insertComponent) as ValueComponentDefinition;
        definition.property = definition.property ?? cd.property;
        input = renderer.build({ ...definition, id: definition.id + "-" + rowIndex }) as InputComponent;
        input.id = input.id + "_" + rowIndex;

        rendered = input.render();
        (row.children[index] as HTMLElement).innerHTML = "";
        (row.children[index] as HTMLElement).append(rendered);

        if (columOptions != null && columOptions[cd.property] != null) {
            renderer.iterateToAddOptions(input, columOptions[cd.property]);
        }
        if (isValueComponent(input) && rowData[index] != null) {
            input.value(rowData[index]);
        }
        tableComponent.restrictions.applyToComponent(input, cd);
        if (this._readOnly) {
            input.setReadOnly(this._readOnly);
        }
        return input;
    }

    public focusoutListener = (evt) => {
        let rowIndex = this.getRowIndexFromElement(evt.target);
        let component = this.components[rowIndex].filter((c) => c["view"].contains(evt.target));
        const indexCol = this.components[rowIndex].indexOf(component[0]);
        if (indexCol === this.getIndexLastInput(rowIndex) || indexCol === this.components[rowIndex].length - 1) {

            let rows = this.tableFootView.querySelectorAll("tr");
            if (this.model.length === rows.length) {
                this.addRow();
                this.table.restrictions.applyDependenciesToNewRow(
                    this.components[this.components.length - 1],
                    null,
                    this.restrictionsDataModel);
                if (!this.tableFootView.contains(document.activeElement)) {
                    let firstComponent = this.components[this.components.length - 1][0];
                    setTimeout(() => {
                        if (isDisplayedComponent(firstComponent)) {
                            (firstComponent.view.querySelector("input, select") as HTMLElement).focus();
                        }
                    }, 0);
                }
            }
        }
    }

    private getIndexLastInput(rowIndex: number): number {
        const listInputs = this.components[rowIndex];
        //Defect, last element of the row
        let index = listInputs.length - 1;
        for (var i = listInputs.length - 1; i >= 0; i--) {
            if ( (listInputs[i] instanceof InputBaseComponent) ||
                (listInputs[i] instanceof InputBaseInputComponent) ) {
                index = i;
                break;
            }
        }

        return index;
    }

    private dataChangedCallback = (evt: CustomEvent<DataChangedEventDetail>) => {
        const evtDetail = evt.detail;
        this.table.status.changed = true;
        let modelRowindex = this.getRowIndexFromElement(evt.target);
        let modelColumnIndex = this.getColumnIndexFromElement(modelRowindex, evt.target);
        this.model[modelRowindex] = this.model[modelRowindex] ?? [];
        this.model[modelRowindex][modelColumnIndex] = evtDetail.data;
        let dataObject = TableDefinitionUtils.rowDataToObject(this.table.definition, this.model[modelRowindex]);

        this.table.restrictions.applyDependenciesToNewRow(
            this.components[modelRowindex],
            this.model[modelRowindex],
            this.restrictionsDataModel);
        this.model[modelRowindex] = TableDefinitionUtils.objectToRowData(this.table.definition, dataObject);
        this.rowValidity[modelRowindex] = this.validate(this.model[modelRowindex], this.components[modelRowindex]);
        evt.stopPropagation();
        this.fireDataChanged();
    }

    public applyDependenciesToNewRows() {
        let idx = 0;
        for (const dataRow of this.components) {
            this.table.restrictions.applyDependenciesToNewRow(
                this.components[idx],
                this.model[idx],
                this.restrictionsDataModel);
            idx++;
        }
    }

    private fireDataChanged() {
        let valid = !this.rowValidity.some((v) => !v);
        let event = new CustomEvent("additionDataChanged", {
            bubbles: true,
            detail: {
                model: this.model,
                valid,
            },
        });
        this.tableFootView.dispatchEvent(event);
    }

    public checkExistingKeyInModel(key: string, rowKey) {
        // Warning, this will probably be slow
        for (const line of this.model) {
            if (key === rowKey.key(line)) {
                return true;
            }
        }
        return false;
    }

    private validate(rowData: any[], components: InputComponent[]): boolean {
        let validate = require("validate.js");
        let currentData = TableDefinitionUtils.rowDataToObject(this.table.definition, rowData);
        let validationResult = validate(
            currentData,
            this.table.restrictions.columnConstraints,
            { fullMessages: false });
        if (validationResult == null) {
            validationResult = {};
        }

        for (const component of components) {
            if (isValidationStatusComponent(component)) {
                if (validationResult[component.definition.property] == null) {
                    component.setValidationStatus(true);
                } else {
                    component.setValidationStatus(
                        false,
                        validationResult[component.definition.property]);
                }
            }
        }
        return (Object.keys(validationResult).length === 0);
    }

    public getRowIndexFromElement(target: any) {
        let nodes = Array.from(this.tableFootView.querySelectorAll("tr"));
        let row = $(target).closest("tr")[0];
        return nodes.indexOf(row);
    }
    public getColumnIndexFromElement(rowIndex, target: any) {
        let nodes = Array.from(this.tableFootView.querySelectorAll("tr")[rowIndex].querySelectorAll("th"));
        let i = nodes.indexOf($(target).closest("th")[0]);
        return i;
    }

    private deleteRow(target: HTMLElement): void {
        let removed = false;
        let index = this.getRowIndexFromElement(target);
        if (this.model.length > index) {
            removed = true;
            this.model.splice(index, 1);
        }
        let rows = this.tableFootView.querySelectorAll("tr");
        if (this.table.definition.allowsInsert === true && this.model.length === rows.length - 1) {
            this.addRow();
        }
        rows[index].remove();
        this.components.splice(index, 1);
        this.rowValidity.splice(index, 1);
        if (removed) {
            this.fireDataChanged();
        }
    }

    public reset = () => {
        this.components = [];
        this.componentPositions = [];
        this.rowValidity = [];
        this.model = [];
        this.newRowCounter = 0;
        this.tableFootView.querySelectorAll("tr.c-table__addition-row").forEach((e) => e.parentNode.removeChild(e));
        this.addRow();
    }
    public setReadOnly(ro: boolean) {
        this._readOnly = ro;
        for (const row of this.components) {
            for (const component of row) {
                component.setReadOnly(ro);
            }
        }
    }
}

export interface AdditionDataChangedEventDetail {
    model: any[][];
    valid: boolean;
}
